import { useQuery } from '@tanstack/react-query'
import { post } from '../fetch'

export type VehicleFilter = {
	id?: string[]
	name?: string
	fulltext?: string
	licensePlate?: string
	[key: string]: unknown
}

export type LocationFilter = {
	id?: string[]
}

export type ReservationFilter = {
	id?: string[]
	[key: string]: unknown
}

export type ReportingFilter = {
	vehicle?: VehicleFilter
	location?: LocationFilter
	reservation?: ReservationFilter
}

export type ReportingRequest = {
	dateFrom: string
	dateTo: string
	filter?: ReportingFilter
	groupBy?: string
}

// Specific request types
export type UtilizationRequest = ReportingRequest

export type LocationDistributionRequest = ReportingRequest & {
	locationType?: 'locationFrom' | 'locationTo'
}

export type LocationRatioRequest = ReportingRequest

export type UtilizationResponse = {
	groupValue: string
	vehicleCount: number
	utilizationPercentage: number
	occupiedDays: number
	reservationCount: number
	plannedRevenue: number
}

export type LocationStats = {
	locationId: string
	count: number
	percentage: number
}

export type LocationDistributionResponse = {
	groupValue: string
	vehicleCount: number
	totalReservations: number
	locationStats: LocationStats[]
}

export type LocationRatioResponse = {
	groupValue: string
	vehicleCount: number
	totalReservations: number
	sameLocationCount: number
	differentLocationCount: number
	sameLocationPercentage: number
	differentLocationPercentage: number
}

const staleTime = 30_000 // 30 seconds for reporting data

export function useReportingUtilization(request: UtilizationRequest) {
	return useQuery({
		queryKey: ['api/reporting/utilization', request],
		queryFn: () => post<UtilizationResponse[]>('/api/0/reporting/utilization', request),
		staleTime,
	})
}

export function useReportingLocationDistribution(request: LocationDistributionRequest) {
	return useQuery({
		queryKey: ['api/reporting/locations/distribution', request],
		queryFn: () =>
			post<LocationDistributionResponse[]>(
				'/api/0/reporting/locations/distribution',
				request,
			),
		staleTime,
	})
}

export function useReportingLocationRatio(request: LocationRatioRequest) {
	return useQuery({
		queryKey: ['api/reporting/locations/ratio', request],
		queryFn: () => post<LocationRatioResponse[]>('/api/0/reporting/locations/ratio', request),
		staleTime,
	})
}
